var map = {
	"./home": [
		293,
		0,
		1,
		4
	],
	"./home.js": [
		293,
		0,
		1,
		4
	],
	"./information": [
		295,
		9,
		8
	],
	"./information.js": [
		295,
		9,
		8
	],
	"./login": [
		297,
		11
	],
	"./login.js": [
		297,
		11
	],
	"./patientDetail": [
		292,
		0,
		1,
		2,
		3,
		5
	],
	"./patientDetail.js": [
		292,
		0,
		1,
		2,
		3,
		5
	],
	"./patientList": [
		296,
		7,
		10
	],
	"./patientList.js": [
		296,
		7,
		10
	],
	"./policy": [
		110
	],
	"./policy.js": [
		110
	],
	"./questions-answers": [
		112
	],
	"./questions-answers.js": [
		112
	],
	"./statistical": [
		294,
		0,
		2,
		6
	],
	"./statistical.js": [
		294,
		0,
		2,
		6
	],
	"./terms-of-use": [
		111
	],
	"./terms-of-use.js": [
		111
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 257;
module.exports = webpackAsyncContext;